module.exports = __webpack_public_path__ + "prod/1.42.2/img/difficulty-four.4dedfcda.png";